import { defineMessage } from 'react-intl';

import TabsContent from '@/components/adg4/tabs-content/src/tabs-content';
import { TeamType } from '@/utils/local-storage-hook';

import AllTeamsTabContent from './all-teams';
import DesignTabContent from './design';
import HRTabContent from './hr';
import MarketingTabContent from './marketing';
import OperationsTabContent from './operations';
import SalesTabContent from './sales';
import SoftwareTabContent from './software';

type Team = {
	teamTypeId: TeamType | undefined;
	icon: string;
	iconSrcSelected?: string;
	videoLink?: string;
	title: {
		id: string;
		defaultMessage: string;
	};
	englishLabel: string;
	tabComponent: React.ReactElement<typeof TabsContent>;
};

export const JSW_FEATURES_TEAM_DATA: Team[] = [
	{
		teamTypeId: 'Software Engineering',
		icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/575h0o4d5531rcso8b6or7m5ljj5yf77.svg',
		title: defineMessage({
			id: 'PaidLandingPage.teamSelectionHero.label.tab1',
			defaultMessage: 'Software',
		}),
		englishLabel: 'Software',
		tabComponent: <SoftwareTabContent />,
	},
	{
		teamTypeId: 'Operations',
		icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yl01ea2raydqsbpq411uu2jb4x1o5k16.svg',
		title: defineMessage({
			id: 'PaidLandingPage.teamSelectionHero.label.tab2',
			defaultMessage: 'Operations',
		}),
		englishLabel: 'Operations',
		tabComponent: <OperationsTabContent />,
	},
	{
		teamTypeId: 'HR',
		icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c85anlqa4vbx8kgn1y41t10q44q0325l.svg',
		title: defineMessage({
			id: 'PaidLandingPage.teamSelectionHero.label.tab3',
			defaultMessage: 'HR',
		}),
		englishLabel: 'HR',
		tabComponent: <HRTabContent />,
	},
	{
		teamTypeId: undefined,
		icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7300dt61p6o2c340nk53534647755fep.svg',
		iconSrcSelected:
			'https://dam-cdn.atl.orangelogic.com/AssetLink/72lkaojcq61b111eyg28t62gv1002f22.svg',
		title: defineMessage({
			id: 'PaidLandingPage.teamSelectionHero.label.tab4',
			defaultMessage: 'All Teams',
		}),
		englishLabel: 'All Teams',
		tabComponent: <AllTeamsTabContent />,
	},
	{
		teamTypeId: 'Marketing',
		icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6648s271ra1efk47v7r40xslp7630o4w.svg',
		title: defineMessage({
			id: 'PaidLandingPage.teamSelectionHero.label.tab5',
			defaultMessage: 'Marketing',
		}),
		englishLabel: 'Marketing',
		tabComponent: <MarketingTabContent />,
	},
	{
		teamTypeId: 'Design',
		icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x82hxxkp01k3f20y83q86a0r0bvm55p4.svg',
		title: defineMessage({
			id: 'PaidLandingPage.teamSelectionHero.label.tab6',
			defaultMessage: 'Design',
		}),
		englishLabel: 'Design',
		tabComponent: <DesignTabContent />,
	},
	{
		teamTypeId: 'Sales',
		icon: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6101e5o3r21du53012037egepyolhibt.svg',
		title: defineMessage({
			id: 'PaidLandingPage.teamSelectionHero.label.tab7',
			defaultMessage: 'Sales',
		}),
		englishLabel: 'Sales',
		tabComponent: <SalesTabContent />,
	},
];
